import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

/**
 * Ümumi (public) shell — QR axını login tələb etmir,
 * ona görə bu layout auth yoxlamır. Login yalnız kupon
 * qazanmaq/baxmaq üçün lazımdır.
 *
 * min-h-dvh: mobil brauzerlərdə 100vh yanlış hesablandığı üçün
 * "dynamic viewport height" istifadə olunur (altda ağ boşluq qalmasın).
 */
const MainLayout = () => {
  return (
    <div className="app-shell flex flex-col bg-gradient-to-br from-indigo-600 via-purple-600 to-fuchsia-600">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
